import React from 'react';
import { LifeBuoy, Mail, Phone, MapPin, ClipboardList } from 'lucide-react';
import { Button } from '../../../components/ui/Button';

export const SupportSection = ({ onOpenTicket }) => {
  return (
    <section className="pt-2 pb-4 max-w-7xl mx-auto px-6">
      <div className="flex flex-col lg:flex-row gap-8 bg-slate-50 p-8 border border-slate-200/60 rounded-2xl">
        <div className="flex-1 space-y-4">
          <div className="flex items-center gap-2 text-blue-600">
            <LifeBuoy size={20} className="animate-pulse" />
            <h3 className="text-lg font-bold tracking-tight text-slate-800">Need Support?</h3>
          </div>
          <p className="text-sm text-slate-550 max-w-md font-light leading-relaxed">
            Having trouble with the application or have a technical query? Our team is available to assist you with installation, troubleshooting, and operations.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-lg bg-white shadow-sm flex items-center justify-center text-amber-500 shrink-0 border border-slate-100">
                <Mail size={16} />
              </div>
              <div>
                <div className="text-[10px] font-bold text-slate-400 uppercase tracking-widest font-sans">
                  Email Support
                </div>
                <div className="text-xs font-bold text-slate-700">
                  info@pinkmoontech.com
                </div>
              </div>
            </div>
            
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-lg bg-white shadow-sm flex items-center justify-center text-blue-500 shrink-0 border border-slate-100">
                <Phone size={16} />
              </div>
              <div>
                <div className="text-[10px] font-bold text-slate-400 uppercase tracking-widest font-sans">
                  Contact Phone
                </div>
                <div className="text-xs font-bold text-slate-700">
                  +91 73962 53199
                </div>
              </div>
            </div>
            
            <div className="flex items-start gap-3 sm:col-span-2">
              <div className="w-8 h-8 rounded-lg bg-white shadow-sm flex items-center justify-center text-emerald-500 shrink-0 border border-slate-100">
                <MapPin size={16} />
              </div>
              <div>
                <div className="text-[10px] font-bold text-slate-400 uppercase tracking-widest font-sans">
                  Office Address
                </div>
                <div className="text-xs font-bold text-slate-700 whitespace-pre-line leading-relaxed">
                  1st Floor, Kunapa Reddy Residency, Ashok Nagar, Vijayawada, Andhra Pradesh
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="lg:w-1/3 flex items-center justify-center bg-white p-8 border border-slate-200 border-dashed rounded-xl transition-all hover:border-blue-500 group">
          <div className="text-center space-y-4 w-full">
            <div className="w-12 h-12 bg-blue-50 rounded-full flex items-center justify-center mx-auto text-blue-600 group-hover:scale-110 transition-transform">
              <ClipboardList size={24} />
            </div>
            <div>
              <h4 className="font-bold text-slate-800">Direct Assistance</h4>
              <p className="text-[11px] text-slate-450 mt-1 font-light">
                Submit a technical ticket directly
              </p>
            </div>
            <Button
              variant="primary"
              fullWidth
              className="shadow-lg shadow-blue-500/10 py-3 text-xs"
              onClick={onOpenTicket}
            >
              Raise a Ticket
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
